export default [
  [
    [1, 6],
    [5, 9],
    [4, 7],
    [3, 10],
    [2, 8],
    [21, 26],
    [25, 29],
    [24, 27],
    [23, 30],
    [22, 28],
    [11, 16],
    [15, 19],
    [14, 17],
    [13, 20],
    [12, 18],
    [31, 36],
    [35, 39],
    [34, 37],
    [33, 40],
    [32, 38]
  ],
  [
    [3, 9],
    [2, 7],
    [1, 10],
    [5, 8],
    [4, 6],
    [23, 29],
    [22, 27],
    [21, 30],
    [25, 28],
    [24, 26],
    [13, 19],
    [12, 17],
    [11, 20],
    [15, 18],
    [14, 16],
    [33, 39],
    [32, 37],
    [31, 40],
    [35, 38],
    [34, 36]
  ],
  [
    [5, 7],
    [4, 10],
    [3, 8],
    [2, 6],
    [1, 9],
    [25, 27],
    [24, 30],
    [23, 28],
    [22, 26],
    [21, 29],
    [15, 17],
    [14, 20],
    [13, 18],
    [12, 16],
    [11, 19],
    [35, 37],
    [34, 40],
    [33, 38],
    [32, 36],
    [31, 39]
  ],
  [
    [2, 10],
    [1, 8],
    [5, 6],
    [4, 9],
    [3, 7],
    [22, 30],
    [21, 28],
    [25, 26],
    [24, 29],
    [23, 27],
    [12, 20],
    [11, 18],
    [15, 16],
    [14, 19],
    [13, 17],
    [32, 40],
    [31, 38],
    [35, 36],
    [34, 39],
    [33, 37]
  ],
  [
    [4, 8],
    [3, 6],
    [2, 9],
    [1, 7],
    [5, 10],
    [24, 28],
    [23, 26],
    [22, 29],
    [21, 27],
    [25, 30],
    [14, 18],
    [13, 16],
    [12, 19],
    [11, 17],
    [15, 20],
    [34, 38],
    [33, 36],
    [32, 39],
    [31, 37],
    [35, 40]
  ],
  [
    [6, 21],
    [10, 24],
    [9, 22],
    [8, 25],
    [7, 23],
    [1, 26],
    [5, 29],
    [4, 27],
    [3, 30],
    [2, 28],
    [11, 31],
    [15, 34],
    [14, 32],
    [13, 35],
    [12, 33],
    [16, 36],
    [20, 39],
    [19, 37],
    [18, 40],
    [17, 38]
  ],
  [
    [8, 24],
    [7, 22],
    [6, 25],
    [10, 23],
    [9, 21],
    [3, 29],
    [2, 27],
    [1, 30],
    [5, 28],
    [4, 26],
    [13, 34],
    [12, 32],
    [11, 35],
    [15, 33],
    [14, 31],
    [18, 39],
    [17, 37],
    [16, 40],
    [20, 38],
    [19, 36]
  ],
  [
    [10, 22],
    [9, 25],
    [8, 23],
    [7, 21],
    [6, 24],
    [5, 27],
    [4, 30],
    [3, 28],
    [2, 26],
    [1, 29],
    [15, 32],
    [14, 35],
    [13, 33],
    [12, 31],
    [11, 34],
    [20, 37],
    [19, 40],
    [18, 38],
    [17, 36],
    [16, 39]
  ],
  [
    [7, 25],
    [6, 23],
    [10, 21],
    [9, 24],
    [8, 22],
    [2, 30],
    [1, 28],
    [5, 26],
    [4, 29],
    [3, 27],
    [12, 35],
    [11, 33],
    [15, 31],
    [14, 34],
    [13, 32],
    [17, 40],
    [16, 38],
    [20, 36],
    [19, 39],
    [18, 37]
  ],
  [
    [9, 23],
    [8, 21],
    [7, 24],
    [6, 22],
    [10, 25],
    [4, 28],
    [3, 26],
    [2, 29],
    [1, 27],
    [5, 30],
    [14, 33],
    [13, 31],
    [12, 34],
    [11, 32],
    [15, 35],
    [19, 38],
    [18, 36],
    [17, 39],
    [16, 37],
    [20, 40]
  ],
  [
    [1, 21],
    [5, 24],
    [4, 22],
    [3, 25],
    [2, 23],
    [6, 26],
    [10, 29],
    [9, 27],
    [8, 30],
    [7, 28],
    [16, 31],
    [20, 34],
    [19, 32],
    [18, 35],
    [17, 33],
    [11, 36],
    [15, 39],
    [14, 37],
    [13, 40],
    [12, 38]
  ],
  [
    [3, 24],
    [2, 22],
    [1, 25],
    [5, 23],
    [4, 21],
    [8, 29],
    [7, 27],
    [6, 30],
    [10, 28],
    [9, 26],
    [18, 34],
    [17, 32],
    [16, 35],
    [20, 33],
    [19, 31],
    [13, 39],
    [12, 37],
    [11, 40],
    [15, 38],
    [14, 36]
  ],
  [
    [5, 22],
    [4, 25],
    [3, 23],
    [2, 21],
    [1, 24],
    [10, 27],
    [9, 30],
    [8, 28],
    [7, 26],
    [6, 29],
    [20, 32],
    [19, 35],
    [18, 33],
    [17, 31],
    [16, 34],
    [15, 37],
    [14, 40],
    [13, 38],
    [12, 36],
    [11, 39]
  ],
  [
    [2, 25],
    [1, 23],
    [5, 21],
    [4, 24],
    [3, 22],
    [7, 30],
    [6, 28],
    [10, 26],
    [9, 29],
    [8, 27],
    [17, 35],
    [16, 33],
    [20, 31],
    [19, 34],
    [18, 32],
    [12, 40],
    [11, 38],
    [15, 36],
    [14, 39],
    [13, 37]
  ],
  [
    [4, 23],
    [3, 21],
    [2, 24],
    [1, 22],
    [5, 25],
    [9, 28],
    [8, 26],
    [7, 29],
    [6, 27],
    [10, 30],
    [19, 33],
    [18, 31],
    [17, 34],
    [16, 32],
    [20, 35],
    [14, 38],
    [13, 36],
    [12, 39],
    [11, 37],
    [15, 40]
  ]
];
